<ion-button [disabled]="disabled || loading" (click)="onClick()" expand="block" [class]="customClass" [color]="color">
  <ng-container *ngIf="ionIconName else noIcon">
    <div [class]="iconOrder === 'left' ? 'icon-left' : 'icon-right'">
      <ion-icon *ngIf="ionIconName && !loading" [name]="ionIconName"></ion-icon>
      {{ label }}
    </div>
  </ng-container>
  <ng-template #noIcon>
    {{ label }}
  </ng-template>
  <ion-spinner *ngIf="loading" name="circular" class="primarySpinner"></ion-spinner>
</ion-button>